import { global_hooks } from 'src/globals';

global_hooks.on('init', init);
function init() {
	const buttons = document.querySelectorAll('.scroll_to_top');

	const init_button = (btn) => {
		btn.addEventListener('click', (e) => {
			e.preventDefault();
			window.scrollTo({
				top: 0,
			});
		});
	};

	buttons.forEach(init_button);

	const v2_buttons = document.querySelectorAll('.scroll_to_top.v2');
	if (v2_buttons.length === 0) return;

	let activated = false;
	let activate_timer = null;

	window.addEventListener('scroll', () => {
		const scrollY = window.scrollY;
		const max_scroll = document.documentElement.scrollHeight - window.innerHeight;
		const progress = max_scroll > 0 ? Math.min(scrollY / max_scroll, 1) : 0;

		v2_buttons.forEach(btn => btn.style.setProperty('--scroll-progress', progress));

		if (scrollY > 0 && !activated) {
			activated = true;
			activate_timer = setTimeout(() => {
				v2_buttons.forEach(btn => btn.classList.add('active-progess'));
			}, 200);
		} else if (scrollY === 0) {
			activated = false;
			clearTimeout(activate_timer);
			v2_buttons.forEach(btn => btn.classList.remove('active-progess'));
		}
	}, { passive: true });
}
